import React from "react";
import DataDisplay from "../../../../../components/dataDisplay/dataDisplay";
import { useSelector } from "react-redux";

export const ScoreCards = () => {
  const scoreCards = useSelector((state) => state.numberOfActiveMembersBy.totalData?.scorecards);

  return (
    <div data-testid={"scorecards"} className={"scorecards"}>
      {scoreCards?.map(({ name, value, change }) => {
        return (
          <DataDisplay
            value={value}
            label={name}
            key={name}
            disableAnimation={true}
            changeProps={{ changeValue: change / 100, showBorder: true }}
          />
        );
      })}
    </div>
  );
};
